var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGaitMainLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5882 0.0459441C28.0627 0.0154559 27.5331 0 26.9999 0C12.0883 0 0 12.0883 0 26.9999C0 41.7346 11.8032 53.7126 26.4705 53.9947V54.0002H28.5882V53.9538C28.5882 53.9538 28.5882 53.9538 28.5882 53.9538V46.7901C28.5882 46.7901 28.5882 46.7901 28.5882 46.7901V25.5444L18.7941 16.0151L17.2059 17.6033L26.4705 26.868V39.3359L11.7794 25.1471L11.1177 27.9265L26.4705 42.4987V46.8458C15.7508 46.5652 7.14702 37.7873 7.14702 26.9999C7.14702 16.0354 16.0354 7.14702 26.9999 7.14702C27.5345 7.14702 28.0642 7.16816 28.5882 7.20964V0.0459441Z",
    fill: "#043927"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0002 27.0007C54.0002 40.4714 44.1352 51.638 31.2356 53.6703V46.4008C40.1652 44.4604 46.8532 36.5116 46.8532 27.0007C46.8532 17.4898 40.1652 9.54095 31.2356 7.60057V0.331055C44.1352 2.36333 54.0002 13.53 54.0002 27.0007ZM31.2354 32.6919V29.2508L40.3677 19.8538L41.6912 22.1037L31.2354 32.6919Z",
    fill: "#55AA8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaitMainLogo);
export default __webpack_public_path__ + "static/media/gait_main_logo.308c8b35b6392eb0fb07903ea65121db.svg";
export { ForwardRef as ReactComponent };